import { formatValidQueryParamUrlCommaSeparated } from "../utils/common";
import { emptySplitApi } from "./empty-split-api";
import {
  CreateDefaultRepairFormsResponse,
  FormTemplatePDFInput,
  FormTemplatesFilters,
  FormTemplatesResponse
} from "./types/form-templates.type";

const extendedFormTemplatesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPracticeFormTemplates: builder.query<
      FormTemplatesResponse,
      FormTemplatesFilters
    >({
      query: ({ practice, ...filters }) =>
        `form-templates/?practice=${practice}&${formatValidQueryParamUrlCommaSeparated(
          filters
        )}&limit=300`,
      providesTags: ["FormTemplates"]
    }),

    createDefaultRepairForms: builder.mutation<
      CreateDefaultRepairFormsResponse,
      void
    >({
      query: () => ({
        url: "/form-templates/create-default-repair-forms/",
        method: "POST"
      }),
      invalidatesTags: ["FormTemplates"]
    }),

    downloadTemplateForm: builder.mutation<Blob, FormTemplatePDFInput>({
      query({
        form_template,
        patient,
        template_data,
        appointment,
        sale,
        clinic,
        order
      }) {
        return {
          url: `/form-templates/${form_template}/?${formatValidQueryParamUrlCommaSeparated(
            {
              patient,
              appointment,
              sale,
              clinic,
              order,
              // The backend json.loads this param; the shared formatter does
              // not URL-encode values, so encode here or a device name with
              // "&" truncates the query string.
              template_data: template_data
                ? encodeURIComponent(JSON.stringify(template_data))
                : undefined
            }
          )}`,
          method: "GET",
          headers: {
            Accept: "application/pdf"
          },
          responseHandler: async (response) => {
            const blob = await response.blob();
            return blob;
          },
          cache: "no-cache"
        };
      },
      invalidatesTags: []
    })
  })
});

export const {
  useGetPracticeFormTemplatesQuery,
  useCreateDefaultRepairFormsMutation,
  useDownloadTemplateFormMutation
} = extendedFormTemplatesApi;
